enum UserRoles {
  STUFF_PORTAL = 'StuffPortal',
  STUFF_PORTAL_WRITE = 'StuffPortalWrite',
}

export default UserRoles;
